// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__lEliu","item":"styles_item__YwAv3","download":"styles_download__uX1jK","itemsWrapper":"styles_itemsWrapper__7OVWl"};